<template>
  <div v-if="articleData">
    <div
      class="video"
      v-for="(item, index) in articleData.articleList"
      :key="index"
      @click="jumpDetail(item)"
    >
      <div class="img-wrap" :style="'background-image: url(' + item.photoPath + ')'">
        <img src="../../../static/image/play.png" />
      </div>
      <div class="video-intro">
        <span class="video-title">{{ item.title }}</span>
        <div class="video-time" v-if="item.modifyTime">
          {{ item.modifyTime.slice(0, 10) }}
        </div>
      </div>
    </div>

    <no-data :articleData="articleData" :loading="loading"></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData';

export default {
  components: {
    NoData,
  },
  props: ['articleData'],
  methods: {
    jumpDetail(val) {
      this.countClick(val.id);
      let query = this.$route.query;
      let params = {
        first: query.first,
        second: query.second,
        detailID: val.id,
        type: 15,
        name: query.name,
      };
      this.$router.push({
        path: 'content',
        query: params,
      });
    },
    countClick(id) {
      let replacement = {
        articleID: id,
      };
      this.$api.countClick(replacement).then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.video {
  width: 100%;
  margin-top: calc-width(15vw);
  margin-bottom: calc-width(10vw);
  padding-bottom: calc-width(10vw);
  border-bottom: 1px solid $border-color;

  .img-wrap {
    z-index: 10;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: calc-width(166vw);
    margin-bottom: calc-width(10vw);
  }

  img {
    z-index: 1;
    width: 100%;
    margin-top: calc-width(62vw);
    margin-left: calc-width(147vw);
    height: calc-width(42vw);
    width: calc-width(42vw);
    opacity: 0.9;
  }

  .video-intro {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .video-title {
    font-size: calc-width(15vw);
    max-width: calc-width(240vw);
    @include text-over;
    font-weight: bold;
  }

  .video-time {
    display: flex;
    font-size: calc-width(12vw);
    align-items: center;
    color: $time-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Video.vue